import {
  GET_PRODUCTION_FINISHED_REQUEST,
  GET_PRODUCTION_FINISHED_SUCCESS,
  GET_PRODUCTION_FINISHED_ERROR,
} from "../actions/types";

export const production_finished = (state = [], action) => {
  const { type, payload } = action;
  switch (type) {
    case GET_PRODUCTION_FINISHED_REQUEST:
      return {
        loading: true,
      };
    case GET_PRODUCTION_FINISHED_SUCCESS:
      return {
        ...state,
        loading: false,
        payload,
      };
    case GET_PRODUCTION_FINISHED_ERROR:
      return {
        ...state,
        loading: false,
        payload,
      };

    default: {
      return state;
    }
  }
};
